import { orderAPI, authAPI } from '../../services/api';

// Action Types
export const ORDER_ACTION_TYPES = {
  // 获取公开SKU列表（不需要登录）
  FETCH_PUBLIC_SKUS_REQUEST: 'FETCH_PUBLIC_SKUS_REQUEST',
  FETCH_PUBLIC_SKUS_SUCCESS: 'FETCH_PUBLIC_SKUS_SUCCESS',
  FETCH_PUBLIC_SKUS_FAILURE: 'FETCH_PUBLIC_SKUS_FAILURE',
  
  // 获取用户可用套餐列表
  FETCH_USER_AVAILABLE_SKUS_REQUEST: 'FETCH_USER_AVAILABLE_SKUS_REQUEST',
  FETCH_USER_AVAILABLE_SKUS_SUCCESS: 'FETCH_USER_AVAILABLE_SKUS_SUCCESS',
  FETCH_USER_AVAILABLE_SKUS_FAILURE: 'FETCH_USER_AVAILABLE_SKUS_FAILURE',
  
  // 清空套餐列表
  CLEAR_USER_AVAILABLE_SKUS: 'CLEAR_USER_AVAILABLE_SKUS',
  
  // 获取原子商品列表
  FETCH_ATOMIC_PRODUCTS_REQUEST: 'FETCH_ATOMIC_PRODUCTS_REQUEST',
  FETCH_ATOMIC_PRODUCTS_SUCCESS: 'FETCH_ATOMIC_PRODUCTS_SUCCESS',
  FETCH_ATOMIC_PRODUCTS_FAILURE: 'FETCH_ATOMIC_PRODUCTS_FAILURE',
  
  // 清空原子商品列表
  CLEAR_ATOMIC_PRODUCTS: 'CLEAR_ATOMIC_PRODUCTS',
  
  // 获取积分交易记录
  GET_POINTS_TRANSACTIONS_REQUEST: 'GET_POINTS_TRANSACTIONS_REQUEST',
  GET_POINTS_TRANSACTIONS_SUCCESS: 'GET_POINTS_TRANSACTIONS_SUCCESS',
  GET_POINTS_TRANSACTIONS_FAILURE: 'GET_POINTS_TRANSACTIONS_FAILURE',
  
  // 清空积分交易记录
  CLEAR_POINTS_TRANSACTIONS: 'CLEAR_POINTS_TRANSACTIONS',
  
  // 创建支付订单
  CREATE_PAYMENT_ORDER_REQUEST: 'CREATE_PAYMENT_ORDER_REQUEST',
  CREATE_PAYMENT_ORDER_SUCCESS: 'CREATE_PAYMENT_ORDER_SUCCESS',
  CREATE_PAYMENT_ORDER_FAILURE: 'CREATE_PAYMENT_ORDER_FAILURE',
  
  // 查询支付状态
  GET_PAYMENT_STATUS_REQUEST: 'GET_PAYMENT_STATUS_REQUEST',
  GET_PAYMENT_STATUS_SUCCESS: 'GET_PAYMENT_STATUS_SUCCESS',
  GET_PAYMENT_STATUS_FAILURE: 'GET_PAYMENT_STATUS_FAILURE',
  
  // 取消支付订单
  CANCEL_PAYMENT_ORDER_REQUEST: 'CANCEL_PAYMENT_ORDER_REQUEST',
  CANCEL_PAYMENT_ORDER_SUCCESS: 'CANCEL_PAYMENT_ORDER_SUCCESS',
  CANCEL_PAYMENT_ORDER_FAILURE: 'CANCEL_PAYMENT_ORDER_FAILURE',
  
  // 清空支付订单状态
  CLEAR_PAYMENT_ORDER: 'CLEAR_PAYMENT_ORDER'
};

// Action Creators

/**
 * 获取公开SKU列表（不需要登录）
 * @param {Object} params - 查询参数
 * @param {boolean} params.popularOnly - 是否只获取推荐套餐
 */
export const fetchPublicSkus = (params = {}) => async (dispatch) => {
  dispatch({ type: ORDER_ACTION_TYPES.FETCH_PUBLIC_SKUS_REQUEST });
  
  try {
    const response = await orderAPI.getSKUList(params);
    
    if (response.success) {
      dispatch({
        type: ORDER_ACTION_TYPES.FETCH_PUBLIC_SKUS_SUCCESS,
        payload: {
          skus: response.data.skus,
          count: response.data.count,
          message: response.message
        }
      });
    } else {
      throw new Error(response.message || '获取公开套餐列表失败');
    }
  } catch (error) {
    dispatch({
      type: ORDER_ACTION_TYPES.FETCH_PUBLIC_SKUS_FAILURE,
      payload: {
        error: error.message || '获取公开套餐列表失败'
      }
    });
    
    // 抛出错误供组件处理
    throw error;
  }
};

/**
 * 获取用户可用套餐列表
 * @param {string} userId - 用户ID
 * @param {Object} params - 查询参数
 * @param {boolean} params.popularOnly - 是否只获取推荐套餐
 */
export const fetchUserAvailableSkus = (userId, params = {}) => async (dispatch) => {
  dispatch({ type: ORDER_ACTION_TYPES.FETCH_USER_AVAILABLE_SKUS_REQUEST });
  
  try {
    const response = await orderAPI.getUserAvailableSkus(userId, params);
    
    if (response.success) {
      dispatch({
        type: ORDER_ACTION_TYPES.FETCH_USER_AVAILABLE_SKUS_SUCCESS,
        payload: {
          skus: response.data.skus,
          count: response.data.count,
          message: response.message
        }
      });
    } else {
      throw new Error(response.message || '获取套餐列表失败');
    }
  } catch (error) {
    dispatch({
      type: ORDER_ACTION_TYPES.FETCH_USER_AVAILABLE_SKUS_FAILURE,
      payload: {
        error: error.message || '获取套餐列表失败'
      }
    });
    
    // 抛出错误供组件处理
    throw error;
  }
};

/**
 * 清空用户可用套餐列表
 */
export const clearUserAvailableSkus = () => ({
  type: ORDER_ACTION_TYPES.CLEAR_USER_AVAILABLE_SKUS
});

/**
 * 获取原子商品列表
 * @param {Object} params - 查询参数
 * @param {string} params.category - 商品分类筛选：translation/document_processing/ai_service/other
 * @param {string} params.billing_type - 计费方式筛选：per_page/per_time
 */
export const fetchAtomicProducts = (params = {}) => async (dispatch) => {
  dispatch({ type: ORDER_ACTION_TYPES.FETCH_ATOMIC_PRODUCTS_REQUEST });
  
  try {
    const response = await orderAPI.getAtomicProducts(params);
    
    if (response.success) {
      dispatch({
        type: ORDER_ACTION_TYPES.FETCH_ATOMIC_PRODUCTS_SUCCESS,
        payload: {
          products: response.data.products,
          pagination: response.data.pagination,
          count: response.data.count
        }
      });
      
      return response.data;
    } else {
      throw new Error(response.message || '获取原子商品列表失败');
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || '获取原子商品列表失败';
    
    dispatch({
      type: ORDER_ACTION_TYPES.FETCH_ATOMIC_PRODUCTS_FAILURE,
      payload: errorMessage
    });
    
    throw new Error(errorMessage);
  }
};

/**
 * 清空原子商品列表
 */
export const clearAtomicProducts = () => ({
  type: ORDER_ACTION_TYPES.CLEAR_ATOMIC_PRODUCTS
});

/**
 * 获取积分交易记录
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.limit - 每页数量
 * @param {string} params.type - 交易类型：consume/refund/recharge
 */
export const getPointsTransactions = (params = {}) => async (dispatch) => {
  dispatch({ type: ORDER_ACTION_TYPES.GET_POINTS_TRANSACTIONS_REQUEST });
  
  try {
    const response = await authAPI.getPointsTransactions(params);
    
    if (response.success) {
      dispatch({
        type: ORDER_ACTION_TYPES.GET_POINTS_TRANSACTIONS_SUCCESS,
        payload: {
          transactions: response.data.transactions,
          pagination: response.data.pagination,
          count: response.data.count
        }
      });
      
      return response.data;
    } else {
      throw new Error(response.message || '获取积分交易记录失败');
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || '获取积分交易记录失败';
    
    dispatch({
      type: ORDER_ACTION_TYPES.GET_POINTS_TRANSACTIONS_FAILURE,
      payload: errorMessage
    });
    
    throw new Error(errorMessage);
  }
};

/**
 * 清空积分交易记录
 */
export const clearPointsTransactions = () => ({
  type: ORDER_ACTION_TYPES.CLEAR_POINTS_TRANSACTIONS
});

/**
 * 创建支付订单
 * @param {string} skuId - 套餐ID
 * @param {string} paymentMethod - 支付方式，默认为wechat
 */
export const createPaymentOrder = (skuId, paymentMethod = 'wechat') => async (dispatch) => {
  dispatch({ type: ORDER_ACTION_TYPES.CREATE_PAYMENT_ORDER_REQUEST });
  
  try {
    const response = await orderAPI.createPaymentOrder(skuId, paymentMethod);
    
    if (response.success) {
      dispatch({
        type: ORDER_ACTION_TYPES.CREATE_PAYMENT_ORDER_SUCCESS,
        payload: response.data
      });
      
      return response.data;
    } else {
      // 创建一个新的错误对象，但保留response信息
      const error = new Error(response.message || '创建支付订单失败');
      error.response = { data: response };
      throw error;
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || '创建支付订单失败';
    
    dispatch({
      type: ORDER_ACTION_TYPES.CREATE_PAYMENT_ORDER_FAILURE,
      payload: errorMessage
    });
    
    // 保留原始错误信息，不要重新包装成新的Error对象
    throw error;
  }
};

/**
 * 查询支付状态
 * @param {string} orderId - 订单ID
 */
export const getPaymentStatus = (orderId) => async (dispatch) => {
  dispatch({ type: ORDER_ACTION_TYPES.GET_PAYMENT_STATUS_REQUEST });
  
  try {
    const response = await orderAPI.getPaymentStatus(orderId);
    
    if (response.success) {
      dispatch({
        type: ORDER_ACTION_TYPES.GET_PAYMENT_STATUS_SUCCESS,
        payload: response.data
      });
      
      return response.data;
    } else {
      throw new Error(response.message || '查询支付状态失败');
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || '查询支付状态失败';
    
    dispatch({
      type: ORDER_ACTION_TYPES.GET_PAYMENT_STATUS_FAILURE,
      payload: errorMessage
    });
    
    throw new Error(errorMessage);
  }
};

/**
 * 取消支付订单
 * @param {string} orderId - 订单ID
 * @param {string} reason - 取消原因
 */
export const cancelPaymentOrder = (orderId, reason = '用户主动取消') => async (dispatch) => {
  dispatch({ type: ORDER_ACTION_TYPES.CANCEL_PAYMENT_ORDER_REQUEST });
  
  try {
    const response = await orderAPI.cancelPaymentOrder(orderId, reason);
    
    if (response.success) {
      dispatch({
        type: ORDER_ACTION_TYPES.CANCEL_PAYMENT_ORDER_SUCCESS,
        payload: response.data
      });
      
      return response.data;
    } else {
      throw new Error(response.message || '取消支付订单失败');
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || '取消支付订单失败';
    
    dispatch({
      type: ORDER_ACTION_TYPES.CANCEL_PAYMENT_ORDER_FAILURE,
      payload: errorMessage
    });
    
    throw new Error(errorMessage);
  }
};

/**
 * 清空支付订单状态
 */
export const clearPaymentOrder = () => ({
  type: ORDER_ACTION_TYPES.CLEAR_PAYMENT_ORDER
});
